<header class="header relative">
  <div class="header-wrapper d-flex align-items-center justify-content-center justify-content-lg-start gap24 w-100 h-100 py-12 px-24 py-28-768 px-48-768 gap-24-768 border-bottom-rgbaGrey500">
    <a class="ielts-logo" href="/">
      <img width="160" height="28" src="/assets/icons/idp_ielts_logo.svg" alt="IDP IELTS Logo" class="w-100 h-100"/>
    </a>
    <div class="progressbarWrapper d-lg-flex d-none w-100 justify-content-center position-absolute">
      <ul class="progressbar d-flex w-100">
        @for (step of steps; track step) {
          <li
            class="steps d-flex flex-column gap-16-768 w-100 position-relative heading6-768 font-semibold txt-grey600-Set2"
            [ngClass]="{'completed': isCompleted(step), 'active': isActive(step)}">
            <span class="step-circle"></span>{{ step.label }}
          </li>
        }
      </ul>
    </div>
    @if (showAgentBadge) {
      <div class="agent-mode-badge d-flex align-items-center gap-8">
        <button type="button" class="agent-mode-trigger d-flex align-items-center gap-8"
          (click)="toggleDropdown()" (keyup.enter)="toggleDropdown()">
          <span class="agent-mode-pill">Agent mode</span>
          <img src="/assets/images/bnb-agent-mode-building.svg" alt="agent" class="agent-mode-icon">
        </button>
        @if (showProfileDropdown) {
          <div
            class="profile-dropdown border-rgbaGrey500 flex-column background-white py-16 gap-12 py-20-768 gap-16-768 round-4 round-4-768 shadow-small z-4 d-flex">
            <div class="logout">
              <button type="button" class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768 w-100"
                (click)="signOut()" (keyup)="signOut()">
                <img src="/assets/images/exit-outline.svg" alt="exit">
                <span class="font-open paragraph-small paragraph-Medium-768">Log out</span>
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
  <div class="mobile-bar d-flex d-lg-none flex-column gap-10 px-24 py-16 justify-content-between border-bottom-rgbaGrey500">
    <h2 class="heading4 text-black text-center">{{ mobileTitle }}</h2>
    <ul class="d-flex gap-8">
      @for (step of steps; track step) {
        <li
          class="steps-bar w-100"
          [ngClass]="{'active': isCompleted(step) || isActive(step)}">
        </li>
      }
    </ul>
  </div>
</header>
